import toast from "react-hot-toast";
import axiosInstance from "./axiosInstance";

const instance = axiosInstance();
instance.defaults.baseURL += "/user";

export async function getUserMetadata() {
  const response = await instance.get(`/get_user_metadata`);
  return response.data;
}

export async function getUserBusinessProfile() {
  const response = await instance.get(`/get_business_profile`);
  return response.data;
}

export async function createUserBusinessProfile(newBusinessProfile) {
  const loadingMessage = newBusinessProfile.website && !newBusinessProfile.profile_description
    ? "Generating business profile and NAICS codes ... 🤖💼"
    : "Updating profile ...";

  const promise = instance.put(`/create_business_profile`, newBusinessProfile, {
    timeout: 60000,
  });

  toast.promise(promise, {
    loading: loadingMessage,
    success: (response) => response.data.message,
    error: "Update failed!",
  });

  const response = await promise;
  return response.data;
}


export async function getUserQueries() {
  const response = await instance.get(`/get_queries`);
  return response.data;
}

export async function createEditUserQuery(newQuery) {
  const response = await instance.post(`/log_query`, newQuery);
  return response.data;
}


export async function emailCancellationReason(cancellationData) {
  try {
    const response = await instance.post(
      `/email_cancellation_reason`,
      cancellationData
    );

    return response.data;
  } catch (error) {
    console.error("Error sending cancellation reason:", error.response?.data || error.message);
    throw error;
  }
}

export async function addCancellationReason(cancellationData) {
  try {
    const response = await instance.post(
      `/add_cancellation_reason`, cancellationData
    );

    return response.data;
  } catch (error) {
    console.error("Error adding cancellation reason:", error.response?.data || error.message);
    throw error;
  }
}

export async function deleteUserQuery(newQuery) {
  const response = await instance.post(`/delete_query`, newQuery);
  return response.data;
}

export async function addUserUploadedDocument({ addData }) {
  const formData = new FormData();
  formData.append("file", addData.file);
  formData.append("type", addData.type);

  const promise = instance.post(`/add_document`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 60000,
  });
  toast.promise(promise, {
    loading: "Processing file 🗄️",
    success: (response) => response.data.message,
    error: (err) => err.response?.data?.detail,
  });
  const response = await promise;
  return response.data;
}

export async function removeUserUploadedDocument(filename) {
  const promise = instance.post(
    `/remove_document`,
    { filename },
    {
      timeout: 60000,
    }
  );
  toast.promise(promise, {
    loading: "Removing file...",
    success: (response) => response.data.message,
    error: (err) => err.response?.data?.detail,
  });
  const response = await promise;
  return response.data;
}

export async function getUploadedDocuments() {
  const response = await instance.get(`/get_uploaded_documents`);
  return response.data;
}
